<mat-card class="cardWithShadow conversation-settings-card">
    <mat-card-content class="p-24">
        <div class="conversation-settings" [formGroup]="settingsForm">
            <div class="conversation-settings__header">
                <h3>Conversation Settings</h3>
                <p>
                    Configure client-wide conversation retention and category labels used by the Conversations page.
                </p>
            </div>

            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Retention Days</mat-label>
                <input matInput formControlName="conversationRetentionDays" min="1" max="3650"
                       placeholder="Leave empty to use default retention" type="number">
                <mat-hint>Applies as default conversation TTL for this client. Leave empty to use fallback defaults.</mat-hint>
                @if (settingsForm.get('conversationRetentionDays')?.hasError('min') || settingsForm.get('conversationRetentionDays')?.hasError('max')) {
                    <mat-error>Value must be between 1 and 3650 days.</mat-error>
                }
            </mat-form-field>

            <mat-form-field appearance="fill" class="full-width">
                <mat-label>Conversation Categories</mat-label>
                <textarea formControlName="conversationCategoriesText"
                          matInput
                          placeholder="Sales&#10;Support&#10;Billing"
                          rows="5"></textarea>
                <mat-hint>One category per line. Blank or unmatched conversations are reported as Uncategorized.</mat-hint>
            </mat-form-field>

            @if (usesLegacyChatbotCategories) {
                <p class="conversation-settings__legacy-note text-muted">
                    Loaded from legacy chatbot category settings. Saving here moves the client to the shared category list.
                </p>
            }

            <div class="conversation-settings__actions">
                <button (click)="saveConversationSettings()"
                        [disabled]="isSavingRetention"
                        color="primary"
                        mat-flat-button
                        type="button">
                    @if (!isSavingRetention) {
                        <span>Save conversation settings</span>
                    } @else {
                        <span>Saving...</span>
                    }
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>
